import { request } from './http';

const createTable = (payload) => request('createTable', {
  body: payload,
  authRequired: true
});

const updateTable = (payload) => request('updateTable', {
  body: payload,
  authRequired: true
});

const deleteTable = (tableId) => request('deleteTable', {
  body: { tableId },
  authRequired: true
});

const createWaiter = (name) => request('createWaiter', {
  body: { name },
  authRequired: true
});

const deleteWaiter = (waiterId) => request('deleteWaiter', {
  body: { waiterId },
  authRequired: true
});

const createSection = (name) => request('createSection', {
  body: { name },
  authRequired: true
});

const deleteSection = (sectionId) => request('deleteSection', {
  body: { sectionId },
  authRequired: true
});

const createTableGroup = (payload) => request('createTableGroup', {
  body: payload,
  authRequired: true
});

const releaseTableGroup = (groupId) => request('releaseTableGroup', {
  body: { groupId },
  authRequired: true
});

const deleteTableGroup = (groupId) => request('deleteTableGroup', {
  body: { groupId },
  authRequired: true
});

export {
  createTable,
  updateTable,
  deleteTable,
  createWaiter,
  deleteWaiter,
  createSection,
  deleteSection,
  createTableGroup,
  releaseTableGroup,
  deleteTableGroup
};
